import { Component } from '@angular/core';

@Component({
  selector: 'kve-projection-tester',
  templateUrl: './projection-tester.component.html',
  styleUrls: ['./projection-tester.component.scss']
})
export class ProjectionTesterComponent {

}
